import { render, staticRenderFns } from "./StaffModal.vue?vue&type=template&id=1d2342cd&"
import script from "./StaffModal.vue?vue&type=script&lang=ts&"
export * from "./StaffModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2342cd')) {
      api.createRecord('1d2342cd', component.options)
    } else {
      api.reload('1d2342cd', component.options)
    }
    module.hot.accept("./StaffModal.vue?vue&type=template&id=1d2342cd&", function () {
      api.rerender('1d2342cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/components/StaffModal.vue"
export default component.exports